import { render, staticRenderFns } from "./ElSocialLinksV2.vue?vue&type=template&id=309c2790"
import script from "./ElSocialLinksV2.vue?vue&type=script&lang=js"
export * from "./ElSocialLinksV2.vue?vue&type=script&lang=js"
import style0 from "./ElSocialLinksV2.vue?vue&type=style&index=0&id=309c2790&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports